const en = {
	signIn: 'Sign In',
	home: 'Courses',
	english: 'English',
	russian: 'Russian',
	hey: 'Hey',
	logout: 'Logout',
	login: 'Login',
	yourEmail: 'Your email',
	email: 'Email',
	password: 'Password',
	register: 'Registration',
	name: 'Name',
	firstName: 'First name',
	lastName: 'Last name',
	confirmPassword: 'Confirm password',
	goToCourse: 'Go to course',
	takeThisCourse: 'Take This Course',
	coursesInProgress: 'Courses in progress',
	availableCourses: 'Available courses',
	completedCourses: 'Completed courses',
	noProgressCourses: "You haven't took any course yet",
	noAvailableCourses:
		'Congratulations, you have finished all available courses!',
	noCompletedCourses: "You haven't accomplished any course yet",
	completeTask: 'Complete task',
	completeTaskAndNext: 'Complete task and move to the next one',
	uncompleteTask: 'Uncomplete task',
	setTaskIncomplete: 'Mark Task as Incomplete',
	replyTo: 'Reply to',
	editComment: 'Edit comment',
	writeComment: 'Write a comment',
	linkLabel:
		'Link (only from: github.com, codepen.io, jsfiddle.net, codesandbox.io)',
	yourMessage: 'Your message',
	whitelistLinksSupport: 'We only support links only from',
	linkIsNotValid: 'Link is not valid',
	reply: 'Reply',
	send: 'Send',
	edit: 'Edit',
	cancel: 'Cancel',
	congrats: 'Congratulations!',
	completeCourseMessage: 'You have finished the course!',
	takeAnotherCourse: 'Take another course',
	hint: 'Hint',
	articles: 'Articles',
	practice: 'Practice',
	theory: 'Theory',
	all: 'All',
	frontend: 'Frontend',
	interview: 'Interview',
	yourProgress: 'Your progress',
	donate: 'Donate',
	requiredField: 'Required field',
	isInvalid: '{{fieldName}} is invalid',
	minLengthValidationError: 'Min number of charachters is {{number}}',
	maxLengthValidationError: 'Max number of charachters is {{number}}',
	hasLatinValidationError: 'only latin letters',
	hasUpperCaseLetterValidationError: 'capital letter',
	hasLowerCaseLetterValidationError: 'lowercase letter',
	hasSpecialCharValidationError: 'special charachter (!@#$*)',
	hasNumberValidationError: 'number',
	passwordValidationGeneral: 'Must contain {{errors}}',
	passwordDoesntMatch: 'Password and confirm password does not match',
	verificationMessageTitle: 'One last thing... Verify your account',
	verificationMessageBody:
		'Please check your email, we have sent you an email with a link to activate your account.',
	resendVerificationQuestion: "Didn't receive a confirmation email?",
	resendVerificationMessage:
		"If you didn't receive a confirmation email, please click on Resend button below and we'll send it you again.",
	resend: 'Resend',
	resendAgain: 'Resend again',
	resendSuccess:
		'We have sent you verificiation link again, please check it on your email',
	resendLastAttempt:
		'If you still cannot find an email with verification link please contact administrator',
	activationSuccessTitle: 'Congrats!',
	activationSuccessBody:
		'You have successfully verified your account! Good luck on your Code Way!',
	activationErrorTitle: 'Oops...',
	activationErrorBody:
		'Something went wrong. Looks like verification is invalid or you have already verified your user.',
	activationErrorResend: 'Please try sending verification instructions again.',
	buttonCompleteTask: 'Mark task as completed',
	buttonIncompleteTask: 'Mark task as incompleted',
	passwordRecovery: 'Recover password',
	emailHasBeenSent: 'Email has been sent',
	enterEmailForgotPassword:
		'Enter your email and we will send you instructions to recover your password',
	emailForgotPasswordInstruction:
		'We have sent you an email with instructions. Please check your email.',
	close: 'Close',
	repeat: 'Repeat',
	createNewPassword: 'Create new password',
	newPasswordSuccessfullyRecovered:
		'You password has been successfully recovered',
	invalidCredentials: 'Invalid credentials',
	dontHaveAnAccount: "Don't have an account? Sign Up",
	forgotPassword: 'Forgot Password?',
	inprogress: 'In progress',
	completed: 'Completed',
	new: 'New',
	noCoursesFound: 'There are no courses found by this filter.',
	status: 'Status',
	category: 'Category',
	clear: 'Clear',
	markTaskAsCompleted:
		'Congrats! You can completed this task and move to the next challenge!',
	taskIsCompleted: 'Congrats! This task is completed!',
	or: 'or',
	and: 'and',
	finishQuizToCompleteTask:
		'Finish the quiz above in order to complete the task',
	moreOptionsNeeded: 'Need to select more options',
	yourAnswer: 'Your answer',
	prev: 'Previous',
	next: 'Next',
	quiz: 'Quiz',
	youCanDoBetter: 'You can do better',
	giveTry: 'give another try',
	youCanDoBetterMore: 'Nice! But you can do better!',
	completeQuizText: 'Congrats! You can complete the task and move forward!',
	wellDone: 'Well done!',
	rightAnswers: 'Right answers',
	checkMistakes: 'Check mistakes',
	tryAgain: 'Try again',
	copyLinkText: 'Copy your link to open codebox',
	codeWasSaved: 'Code was saved',
	copy: 'Copy',
	copied: 'Copied',
	myAccount: 'My account',
	profile: 'Profile',
	orders: 'Orders',
	company: 'Company',
	position: 'Position',
	emptyInlineTextValue: 'N/A',
	pricing: 'Pricing',
	forSubscribersOnly: 'Available for plans {{plans}}',
	taskPlanDemandText:
		"It's great that you've reached this stage! This task is available for Standard and PRO plans. Please choose your plan and get access to this task :)",
	maxSizeAvatarError:
		'Max size of the image is: {{maxSize}}. Size of this image is {{actualSize}}.',
	imageTypeError: 'Allowed image types are: {{allowedExtentions}}',
	free: 'Free',
	standard: 'Standard',
	pro: 'Pro',
	seeAllPlans: 'See all plans',
	subscriptionPlan: 'Subscription Plan',
	subscriptionPlans: 'Subscription Plans',
	month: 'Month',
	currentPlan: 'Current plan',
	subscribe: 'Subscribe',
	services: 'Mentorship',
	order: 'Order',
	theOrder: 'Order',
	moreDetails: 'More details',
	purchase: 'Purchase',
	currentPosition: 'Current position',
	desiredPosition: 'Desired position',
	interviewType: 'Interview type',
	technicalInterview: 'Technical',
	hrInterview: 'HR',
	screeningInterview: 'Screening',
	matchingInterview: 'Matching',
	writeYourQuestions: 'Write your questions',
	fileAttached: 'File attached',
	CV: 'CV',
	nA: 'N/A',
	fillOrderDetails: 'Fill order details',
	upload: 'Upload',
	remove: 'Remove',
	removeFile: 'Remove file',
	thankYou: 'Thank you!',
	thankYouOrder:
		'We are pleased to say that your order was received successfully.',
	thankYouLinkInstructions:
		'Click this button to choose an available time slot which is convenient to you',
	chooseTimeSlot: 'Choose a time slot',
	afterSchedulingMeetingInfo:
		'After scheduling a meeting you will receive confirmation to your email',
	emailDuplcatedThankyou:
		'You will soon receive an email containing all the details you need, including a Zoom link and a calendar event. Please review the information and get ready for our upcoming discussion.',
	lookingForwardToConnecting: 'We look forward to connecting with you!',
	date: 'Date',
	productName: 'Product name',
	price: 'Price',
	orderNumber: 'Order number',
	orderStatus: 'Order status',
	taskOverview: 'Task overview',
	taskConclusion: 'Now you know',
	codeTask: 'Code task',
	video: 'Video',
	editPhoto: 'Edit photo',
	hello: 'Hello',
	noOrderFound: 'There is no order found.',
	oldPasswordDoesntMatch: 'Old password doesn’t match',
	changePasswordSuccess: 'You password has been successfully changed',
	contactUsFormdSuccess:
		'Thank you! We received your message and will get back to you soon.',
	contactUsFormError: 'Something went wrong. Try again later',
	general: 'General',
	support: 'Support',
	sales: 'Sales',
	сontact: 'Contact',
	contactUs: 'Contact us',
	resizableHint: 'Click on right bottom corner and hold to drag and resize',
	gotIt: 'Got it!',
	accept: 'Accept',
	moreInformation: 'More information',
	replay: 'Replay',
	delete: 'Delete',
	runCode: 'Run code',
	testCode: 'Test code',
	reset: 'Reset',
	postToComments: 'Post to comments',
	save: 'Save',
	expand: 'Expand',
	changeView: 'Change view',
	back: 'Back',
	code: 'Code',
	addLink: 'Add link',
	oldPassword: 'Old Password',
	newPassword: 'New Password',
	solution: 'Solution',
	servicesSlogan:
		'Accelerate your success: Elevate learning with our expert services!',
	subscriptionSlogan:
		'Select your path to success: Find the perfect plan for your journey!',
	linkToGithub: 'Link to Github',
	to_courses: 'To courses',
	console: 'Console',
	tests: 'Tests',
	in_this_lesson: 'In this lesson:',
	apiControl: 'APIs',
};

export default en;
